import BackIcon from '@mui/icons-material/ArrowBackRounded';
import CloseIcon from '@mui/icons-material/CloseRounded';
import { Box, Divider, IconButton, Typography } from '@mui/material';
import type { ReactNode, MouseEvent } from 'react';
import { createPortal } from 'react-dom';
import { Button } from '../../../Button/Button';
import { FULL_HEIGHT_PANEL_PORTAL_CLASSNAME } from '../../model/constants';

interface Props {
  children: ReactNode;
  title: string;
  open: boolean;
  onApply: () => void;
  onClose: () => void;
}

export function AddPanel({ open, title, children, onApply, onClose }: Props) {
  if (!open) {
    return null;
  }

  const handlePanelClick = (event: MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
  };

  return createPortal(
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      }}
      onClick={handlePanelClick}
    >
      <Box
        sx={{
          py: 3,
          pl: 1.5,
          pr: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          backgroundColor: '#F1F3F8',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <IconButton sx={{ p: 0 }} onClick={onClose}>
            <BackIcon />
          </IconButton>
          <Typography
            variant="h3"
            sx={{
              fontWeight: 500,
              fontSize: '1.5em',
              lineHeight: '1.75rem',
              letterSpacing: 0,
            }}
          >
            {title}
          </Typography>
        </Box>
        <IconButton sx={{ p: 0 }} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>
      {children}
      <Divider />
      <Box sx={{ p: 2, display: 'flex', gap: 2 }}>
        <Button
          sx={{ lineHeight: '1.125rem', borderRadius: 2 }}
          onClick={onApply}
        >
          Apply
        </Button>
        <Button
          variant="outlined"
          color="secondary"
          sx={{ lineHeight: '1.125rem', borderRadius: 2 }}
          onClick={onClose}
        >
          Cancel
        </Button>
      </Box>
    </Box>,
    document.querySelector(
      `.${FULL_HEIGHT_PANEL_PORTAL_CLASSNAME}`,
    ) as HTMLElement,
  );
}
